<template>
    <icon-arrow-long v-bind="$attrs" />
</template>

<script>
import IconArrowLong from "@/components/publish/styles/icons/icon-arrow-long.vue";
export default {
    props: {},
    components: {
        IconArrowLong,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
